import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

(function () {
    'use strict';

    angular
        .module('app')
        .directive('minimumLotRuntimeValidator', minimumLotRuntimeValidator);

    /**
     * Validate minimum lot runtime
     *
     * @author bjnowak.btc
     * @ngInject
     */
    function minimumLotRuntimeValidator(createProposalService) {
        return {
            restrict: 'A',
            scope: {
                proposalRuntime: '=',
                minimumLotUnit: '=',
                selectLotUnit: '=',
                disableValidator: '='
            },
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                ctrl.$validators.minimumLotRuntimeValidator = function (
                    modelValue,
                    viewValue
                ) {
                    if (scope.disableValidator) {
                        return true;
                    }

                    // validate minimum lot runtime against proposal runtime; if  proposal runtime is smaller than
                    // minimum lot runtime, no response could fulfil the minimum requirement
                    if (
                        angular.isUndefined(scope.proposalRuntime) ||
                        angular.isUndefined(scope.proposalRuntime.start) ||
                        angular.isUndefined(scope.proposalRuntime.end) ||
                        angular.isUndefined(scope.selectLotUnit)
                    ) {
                        return true;
                    }

                    var minimum = modelValue || viewValue;
                    var runtimeStart = moment(scope.proposalRuntime.start);
                    var runtimeEnd = moment(scope.proposalRuntime.end);

                    var result = true;
                    switch (scope.selectLotUnit) {
                        case createProposalService.minLotRuntimeUnits.HOUR: {
                            if (
                                durationInHours(runtimeStart, runtimeEnd) <
                                minimum
                            ) {
                                result = false;
                            }
                            break;
                        }
                        case createProposalService.minLotRuntimeUnits.DAY: {
                            if (
                                durationInDays(runtimeStart, runtimeEnd) <
                                minimum
                            ) {
                                result = false;
                            }
                            break;
                        }
                        case createProposalService.minLotRuntimeUnits.MONTH: {
                            if (
                                durationInMonths(runtimeStart, runtimeEnd) <
                                minimum
                            ) {
                                result = false;
                            }
                            break;
                        }
                    }
                    return result;
                };

                function durationInHours(start, end) {
                    return end.diff(start, 'hours');
                }

                function durationInDays(start, end) {
                    return end.diff(start, 'days');
                }

                function durationInMonths(start, end) {
                    return end.diff(start, 'months');
                }

                scope.$watchGroup(
                    [
                        'selectLotUnit',
                        'proposalRuntime.start',
                        'proposalRuntime.end'
                    ],
                    function () {
                        ctrl.$validate();
                        ctrl.$setDirty();
                    }
                );
            }
        };
    }
})();
